import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useStyles } from "../styles";

type ColorsAndTagProps = {
  expanded?: boolean;
  onChange?: (isExpanded: boolean) => void;
};

export function ColorsAndTag({ expanded, onChange }: ColorsAndTagProps) {
  const styles = useStyles();

  return (
    <Accordion
      expanded={expanded}
      elevation={0}
      className={styles.rootAccordion}
      onChange={(_, isExpanded) => (onChange ? onChange(isExpanded) : {})}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography>Cores e etiquetas</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography variant="body2" color="GrayText">
          As informações da loja selecionada aparecerão na sua imagem. Por
          exempo: logo, endereço e número de telefone.
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
}
